import { render, staticRenderFns } from "./Grid22.vue?vue&type=template&id=5e354489&scoped=true"
import script from "./Grid22.vue?vue&type=script&lang=ts"
export * from "./Grid22.vue?vue&type=script&lang=ts"
import style0 from "./Grid22.vue?vue&type=style&index=0&id=5e354489&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e354489",
  null
  
)

export default component.exports